<div class="cont-search-box cont-search-box-top-header" [ngStyle]="{'background-color': colorNav}"
  [class.with-voice-search]="hasVoiceSearch">
  <div class="cont-input-search" autocomplete="off" action="#">
    <div class="cont-select-deparment" [ngClass]="{'border-r-cont-deparment': toggleListDeparments}"
      (click)="toggleListDeparments = !toggleListDeparments">
      <p>{{optionDeparments.substr(0,10)}} <app-icons *ngIf="showAllComponents" class="icon-arrow" [color]="'#418fde'"></app-icons> </p>
      <div class="cont-select-list" [ngClass]="{'show-option-list': toggleListDeparments}">
        <ul>
          <li (click)="selectDeparment('Todos')" [id]="idPrefix + 'algolia-search-box-select-department'">Todas</li>
          <li *ngFor="let deparment of arrayDeparments" (click)="selectDeparment(deparment.name)"
            [id]="idPrefix + 'algolia-search-box-department-' + deparment.id">{{deparment.name}}</li>
        </ul>
      </div>
    </div>
    <app-icons class="icon-search" [type]="'search'" (click)="onTyping(); showRecommended = false"></app-icons>
    <label class="label">
      <input type="text" aria-label="Buscador" name="searchTextBox" [(ngModel)]="input.search"
        id="nav-bar-algolia-search-box" placeholder="Busca aquí tu producto"
        autocomplete="off" (focus)="showRecommended=true" (keyup.enter)="showRecommended = false">
    </label>
    <button class="btn-clear-text d-block d-sm-none" *ngIf="input.search != ''" (click)="input.search = ''"><span
        class="text-close">X</span></button>
    </div>
  <ng-container #voiceSearch *ngIf="showAllComponents && isBrowser && !screenSize?.mobile"></ng-container>
</div>

<ng-container *ngIf="showAllComponents && showRecommended && input.search === '' ">
  <app-recommended (recommendedItem)="searchRecommended($event)" (isClose)="showRecommended=false"></app-recommended>
</ng-container>
